export default "__VITE_ASSET__667b79ca__"